module.exports = __webpack_public_path__ + "static/img/group-5.aac56606.png";